import React from 'react';
import s from '../../PromoBadge.scss';
const HexagonLocked16 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "16",
        height: "16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.974.253a2 2 0 0 0-1.948 0l-5 2.786A2 2 0 0 0 0 4.786v5.452a2 2 0 0 0 1.026 1.747l5 2.787a2 2 0 0 0 1.948 0L10 13.642V11.58c0-.06.028-.118.077-.16a.285.285 0 0 1 .185-.067h.613v-1.289c.001-.6.278-1.176.77-1.601.492-.425 1.16-.664 1.855-.664.169 0 .336.014.5.042V4.786a2 2 0 0 0-1.027-1.747l-5-2.786Z",
        className: s['fill-color']
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.5 8.824c-.497 0-.973.202-1.325.562-.351.36-.55.846-.55 1.355v1.326h-.438c-.05 0-.097.02-.132.056a.194.194 0 0 0-.055.136v3.549a.194.194 0 0 0 .116.177c.023.01.047.015.072.015h4.624a.185.185 0 0 0 .174-.119.194.194 0 0 0 .014-.073v-3.55a.194.194 0 0 0-.116-.176.185.185 0 0 0-.072-.015h-.437v-1.326c0-.509-.199-.996-.55-1.355a1.856 1.856 0 0 0-1.325-.562Zm.312 5.238v.83a.323.323 0 0 1-.091.226.308.308 0 0 1-.441 0 .323.323 0 0 1-.092-.225v-.83a.642.642 0 0 1-.27-.312.66.66 0 0 1 .197-.762.623.623 0 0 1 .77 0 .66.66 0 0 1 .197.762.642.642 0 0 1-.27.311Zm-1.407-1.995v-1.326a1.141 1.141 0 0 1 .32-.794 1.093 1.093 0 0 1 .775-.33 1.074 1.074 0 0 1 .775.33 1.123 1.123 0 0 1 .32.794v1.326h-2.19Z",
        className: s['fill-color']
    }));
HexagonLocked16.displayName = 'HexagonLocked16';
export default HexagonLocked16;

//# sourceMappingURL=Locked.js.map